import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterBooleanSearchValueObject} from './FilterBooleanSearchValueObject.js'

export class FilterHasStockSearchValueObject extends ValueObject {
  #hasStock

  constructor({hasStock}) {
    super()
    this.#hasStock = hasStock
  }

  static create({hasStock}) {
    return new FilterHasStockSearchValueObject({hasStock: FilterBooleanSearchValueObject.create(hasStock)})
  }

  static createWithDefaultValue({config, hasStock}) {
    const {DEFAULT_HAS_STOCK_SEARCH} = config.get('searchFilters')

    return new FilterHasStockSearchValueObject({
      hasStock: FilterBooleanSearchValueObject.create({boolean: hasStock ?? DEFAULT_HAS_STOCK_SEARCH})
    })
  }

  static createQueryParams({config, hasStock}) {
    const {DEFAULT_HAS_STOCK_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterHasStockSearchValueObject({
      hasStock: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.HAS_STOCK],
        value: hasStock === DEFAULT_HAS_STOCK_SEARCH ? null : hasStock
      })
    })
  }

  get isEmpty() {
    return this.#hasStock.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#hasStock.queryParam})
    }
  }

  get value() {
    return this.#hasStock.value
  }

  toJSON() {
    return {
      hasStock: this.#hasStock.toJSON()
    }
  }
}
